import type { InvitationResource } from '@/features/iam/api/resources/invitations'
import { Id } from '@/infra/id'
import type { Invitation, InvitationStatus } from './Invitation'

export function mapInvitationResourceToInvitation(
  resource: InvitationResource,
): Invitation {
  return {
    token: resource.token,
    workspaceId: Id.assert(resource.workspace_id),
    status: mapInvitationStatusResourceToStatus(resource.status),
  }
}

function mapInvitationStatusResourceToStatus(
  status: InvitationResource['status'],
): InvitationStatus {
  switch (status) {
    case 'PENDING':
      return 'Pending'
    case 'ACCEPTED':
      return 'Accepted'
    case 'EXPIRED':
      return 'Expired'
  }
}
